var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 7.33333C1.66663 7.33333 1.76773 6.62563 4.69666 3.6967C7.62559 0.767767 12.3743 0.767767 15.3033 3.6967C16.341 4.73443 17.011 6.0006 17.3134 7.33333M1.66663 7.33333V2.33333M1.66663 7.33333H6.66663M18.3333 10.6667C18.3333 10.6667 18.2322 11.3744 15.3033 14.3033C12.3743 17.2322 7.62559 17.2322 4.69666 14.3033C3.65893 13.2656 2.98887 11.9994 2.68648 10.6667M18.3333 10.6667V15.6667M18.3333 10.6667H13.3333",
    stroke: "#001752",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.26513f6ac7e9938d298ca600d428c1af.svg";
export { ForwardRef as ReactComponent };